import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
// import { JsonEditorOptions } from 'ang-jsoneditor';
import { MachineOwnerService } from 'src/app/shared/services/owner.service';
import { ServiceDataService } from 'src/app/shared/services/service-data.service';
import { MachineServiceData } from 'src/api/generated';

@Component({
  selector: 'app-service-data-detail',
  templateUrl: './service-data-detail.component.html',
  styleUrl: './service-data-detail.component.scss'
})
export class ServiceDataDetailComponent {
  private _unsubscriber = new Subject();
  public data: any;
  public isDataChanged: boolean = false;
  private _changedData: any;
  private _currentData: MachineServiceData | undefined;

  @Input() id: string | undefined;

  constructor(
    private _sdSvc: ServiceDataService,
    private _oSvc: MachineOwnerService,
    private _router: Router
  ){
    this._sdSvc.oneEntity$.pipe(takeUntil(this._unsubscriber)).subscribe((e) => {
      if(e != null && e.Data != null){
        this.data = JSON.parse(e.Data);
        this._currentData = e;
      }else{
        this.data = {};
        this._currentData = undefined;
      }
    })
  }

  ngOnInit(): void {
    this._sdSvc.LoadOne(this.id ?? "");
  }

  ngOnDestroy(): void {
    this._unsubscriber.next(null);
    this._unsubscriber.complete();
  }

  public get SdSvc(): ServiceDataService {
    return this._sdSvc;
  }

  public getTranslateOwnerIdToName(a: string | undefined):  string | undefined {
    if(a != undefined) {
      return this._oSvc.getOwnerNameById(a);
    }else{
      return undefined;
    }
  }

  getTranslateUserIdToName(a: string | undefined):  string | undefined {
    if(a != undefined) {
      return this._sdSvc.getUserNameById(a);
    }else{
      return undefined;
    }
  }

  saveDuplicate(){
    if(this._currentData != undefined){
      this.isDataChanged = false;

      let duplicateServiceData: MachineServiceData = {
        Data: JSON.stringify(this._changedData),
        UserId: this._currentData.UserId,
        OwnerId: this._currentData.OwnerId,
        Name: this._currentData.Name,
        Version: this._currentData.Version,
        FenixVersion: this._currentData.FenixVersion,
        Tags: this._currentData.Tags,
        Id: this._currentData.Id,
        Created: this._currentData.Created,
        Modified: this._currentData.Modified,
        SourceId: this._currentData.SourceId
      }

      try {
        if (this.data != this._changedData) {
          this._sdSvc.SaveDuplicate(duplicateServiceData);
        }
      } finally {
        this._router.navigate(['service-data']);
      }
    } else{
      //TODO show popup with error
    }
  }

  onChangeJson(event: any){
    if(!event.isTrusted){
      this._changedData = event;
    }

    if(!this.isDataChanged){
      this.isDataChanged = true;
    }
  }
}
